<h1 mat-dialog-title>{{ titleKey | transloco }}</h1>

<div mat-dialog-content>
  <p>{{ contentKey | transloco }}</p>

  <div mat-dialog-actions>
    <button mat-flat-button data-testid="cancelEndHalf" [mat-dialog-close]="{action: 'cancel'}">{{ 'endQuarter.cancelBtn' | transloco }}</button>
    @if (isOvertimeButtonEnabled) {
      <button mat-flat-button class="overtime-btn" data-testid="overTime" [mat-dialog-close]="{action: 'overtime'}">{{ 'endQuarter.overtimeBtn' | transloco }}</button>
    }
    <button mat-flat-button color="primary" data-testid="saveEndHalf" [mat-dialog-close]="{action: 'end'}">{{ buttonKey | transloco }}</button>
  </div>
</div>
